
// import styles from "./VenueSpaceCard.module.css";

// export default function VenueSpaceCard({ space }) {

//   const image = space.images?.[0]?.image;

//   return (

//     <div className={styles.card}>

//       {/* {image ? (

//         <img
//           src={image}
//           alt={space.name}
//           className={styles.image}
//         />

//       ) : (

//         <div className={styles.placeholder}>
//           No Image
//         </div>

//       )} */}

//       <div className={styles.content}>

//         <h3>{space.name}</h3>

//         <p className={styles.type}>
//           {space.space_type?.replaceAll("_", " ")}
//         </p>

//         {space.max_capacity && (

//           <p>

//             <strong>Capacity :</strong>

//             {" "}
//             {space.max_capacity} Guests

//           </p>

//         )}

//         {space.area && (

//           <p>

//             <strong>Area :</strong>

//             {" "}
//             {space.area} sq.m

//           </p>

//         )}

//         {space.description && (

//           <p className={styles.description}>
//             {space.description}
//           </p>

//         )}

//       </div>

//     </div>

//   );

// }




import styles from "./VenueSpaceCard.module.css";

export default function VenueSpaceCard({ space }) {

  const image = space.images?.[0]?.image;

  // Format dimensions
  const dimensions = space.dimensions
    ? /\bft\b/i.test(space.dimensions)
      ? space.dimensions
      : `${space.dimensions} ft`
    : space.length && space.width
      ? `${space.length} × ${space.width}${
          space.height ? ` × ${space.height}` : ""
        } ft`
      : null;

  return (

    <div className={styles.card}>

      {/* Image */}

      {/* {image ? (
        <img
          src={image}
          alt={space.name}
          className={styles.image}
        />
      ) : (
        <div className={styles.placeholder}>
          No Image
        </div>
      )} */}

      <div className={styles.content}>

        <h3>{space.name}</h3>

        <p className={styles.type}>
          {space.space_type?.replaceAll("_", " ")}
        </p>

        {space.max_capacity && (
          <p>
            <strong>Capacity :</strong>{" "}
            {space.max_capacity} Guests
          </p>
        )}

        {/* Dimensions */}
        {dimensions && (
          <p>
            <strong>Dimensions :</strong>{" "}
            {dimensions}
          </p>
        )}

        {space.area && (
          <p>
            <strong>Area :</strong>{" "}
            {space.area} sq.ft
          </p>
        )}

        {space.description && (
          <p className={styles.description}>
            {space.description}
          </p>
        )}

      </div>

    </div>

  );
}
